/* Пример контекста окна подтверждения
{
  title: '',
  description: '',
  revertButtons: true,
  actionText: '',
  cancelText: '',
  style: 'danger',
  action: () => {},
  component: null,
  data: {}
}
*/

export const state = () => ({
  open: false,
  component: null,
  context: {},
});

export const mutations = {
  open(state, context) {
    state.open = true;
    state.context = context;
    state.component = context?.component || null;
  },
  destroyComponent(state) {
    state.context = null;
    state.component = null;
  },
  changeData(state, { key, value }) {
    state.context.data[key] = value;
  },
  close(state) {
    state.open = false;
  },
};

export const actions = {
  openModal({ commit }, context) {
    commit('open', context);
  },
  closeModal({ commit }) {
    commit('close');
    commit('destroyComponent');
  },
};

export default { namespaced: true, state, mutations, actions };
